import { FC } from 'react';
import { IconLongArrowRightRegular, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  onClick?: () => void;
  text: string;
};

export const MoreButton: FC<React.PropsWithChildren<Props>> = ({ text, onClick }) => {
  return (
    <Root onClick={onClick}>
      <ProductCarouselMoreButton>
        <IconLongArrowRightRegular size={24} color='iconSecondary' />
      </ProductCarouselMoreButton>
      <Text
        as='span'
        css={css`
          margin: 8px 0 0;
        `}
        variant='Body_13_SemiBold'
        color='textSecondary'
      >
        {text}
      </Text>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
  aspect-ratio: 0.834;
  padding: 0;
  cursor: pointer;
`;

const ProductCarouselMoreButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 48px;
  max-height: 48px;
  width: 8vw;
  height: auto;
  border-radius: 50%;
  border: 1px solid ${vars.color.gray150};
  aspect-ratio: 1;
`;
